import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Рекреационный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Вид массового туризма с целью лечения и отдыха, восстановления и развития физических, психических и эмоциональных сил.</p>
                    <p>Рекреационный туризм может отличаться большим разнообразием и включать зрелищные и развлекательны программы и т. п.</p>
                </div>
            </div>
        </>
    );
}